import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseResponse, BaseResponseObj } from 'ccc-commons/dist/core';
import { License } from '../models/license.model';
import { XrefNumber } from '../models/xref-number.model';

@Injectable()
export class LicensesService {
  apiUrl = environment.apiUrl + '/organizations';


  constructor(private http: HttpClient) { }

  getOrganizationLicenses(orgId, params): Observable<BaseResponse<License>> {

    const httpParams = new HttpParams({ fromObject: params });
    return this.http.get<BaseResponse<License>>(`${this.apiUrl}/${orgId}/licenses`, { params: httpParams });

  }

  createOrganizationLicense(license: License, orgId): Observable<BaseResponse<License>> {
    license.purchasedSeats = parseInt('' + license.purchasedSeats, 10);
    return this.http.post<BaseResponse<License>>(`${this.apiUrl}/${orgId}/licenses`, license);
  }

  getProgramLicenseCodes(): Observable<BaseResponse<string[]>> {
    return this.http.get<BaseResponse<string[]>>(`${environment.apiUrl}/products/codes?sort=-product`);
  }

  updateOrganizationLicense(license: License, orgId, licenseId): Observable<BaseResponse<License>> {
    license.purchasedSeats = parseInt('' + license.purchasedSeats, 10);
    return this.http.put<BaseResponse<License>>(`${this.apiUrl}/${orgId}/licenses/${licenseId}`, license);
  }

  uploadLicensesCvsFile(orgId, file: File): Observable<BaseResponseObj<XrefNumber>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<BaseResponseObj<XrefNumber>>(`${this.apiUrl}/${orgId}/licenses/import`, formData);
  }

  downloadCsvTemplate(orgId): Observable<BaseResponseObj<any>> {
    return this.http.get(`${this.apiUrl}/${orgId}/licenses/template`, { responseType: 'blob', observe: 'response' });
  }

  downloadLicensesCvsFile(orgId): Observable<BaseResponseObj<any>> {
    return this.http.get(`${this.apiUrl}/${orgId}/licenses/export`, { responseType: 'blob', observe: 'response' });
  }

}
